type ErrorProps = {
    severity?: 'high' | 'low';
    message: string;
    property?: string;
    id?: string;
    statusCode?: number;
};

export class ResponseError extends Error {
    public readonly message: string;
    public readonly severity: 'high' | 'low' = 'low';
    public readonly id?: string;
    public readonly property?: string;
    public readonly statusCode?: number;

    constructor({ message, id, property, severity, statusCode }: ErrorProps) {
        super(message);
        this.message = message;
        this.id = id;
        this.property = property;
        this.severity = severity ?? 'low';
        this.statusCode = statusCode;
    }
}
